module.exports = __webpack_public_path__ + "img/F - 02.5c28015f.png";